import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import Select from '../../account/ComparisonCalculator/select';

export const TaxResidencySelect = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => unknown;
}) => {
  const options = useMemo(
    () =>
      Object.keys(isoCodeToCountryNameMapping).map((countryCode) => ({
        value: countryCode,
        translate: false as const,
        label: isoCodeToCountryNameMapping[countryCode as keyof typeof isoCodeToCountryNameMapping],
      })),
    [isoCodeToCountryNameMapping],
  );

  return (
    <div className="mb-3">
      <label className="form-label" htmlFor="tax-residency">
        <FormattedMessage id="withdrawals.personalDetails.bankAccount.taxResidencyLabel" />
      </label>
      <Select id="tax-residency" options={options} selected={value} onChange={onChange} />
    </div>
  );
};

const isoCodeToCountryNameMapping = {
  AFG: 'Afganistan',
  ALA: 'Ahvenamaa',
  ALB: 'Albaania',
  DZA: 'Alžeeria',
  ASM: 'Ameerika Samoa',
  USA: 'Ameerika Ühendriigid',
  AND: 'Andorra',
  AGO: 'Angola',
  AIA: 'Anguilla',
  ATA: 'Antarktis',
  ATG: 'Antigua ja Barbuda',
  ARE: 'Araabia Ühendemiraadid',
  ARG: 'Argentina',
  ARM: 'Armeenia',
  ABW: 'Aruba',
  AZE: 'Aserbaidžaan',
  AUS: 'Austraalia',
  AUT: 'Austria',
  BHS: 'Bahama',
  BHR: 'Bahrein',
  BGD: 'Bangladesh',
  BRB: 'Barbados',
  PLW: 'Belau',
  BEL: 'Belgia',
  BLZ: 'Belize',
  BEN: 'Benin',
  BMU: 'Bermuda',
  BTN: 'Bhutan',
  BOL: 'Boliivia',
  BES: 'Bonaire, Sint Eustatius ja Saba',
  BIH: 'Bosnia ja Hertsegoviina',
  BWA: 'Botswana',
  BVT: "Bouvet' saar",
  BRA: 'Brasiilia',
  IOT: 'Briti India ookeani ala',
  VGB: 'Briti Neitsisaared',
  BRN: 'Brunei',
  BGR: 'Bulgaaria',
  BFA: 'Burkina Faso',
  BDI: 'Burundi',
  COL: 'Colombia',
  COK: 'Cooki saared',
  CRI: 'Costa Rica',
  CUW: 'Curaçao',
  DJI: 'Djibouti',
  DMA: 'Dominica',
  DOM: 'Dominikaani Vabariik',
  ECU: 'Ecuador',
  EST: 'Eesti',
  EGY: 'Egiptus',
  GNQ: 'Ekvatoriaal-Guinea',
  CIV: 'Elevandiluurannik',
  SLV: 'El Salvador',
  ERI: 'Eritrea',
  ETH: 'Etioopia',
  FLK: 'Falklandi saared',
  FJI: 'Fidži',
  PHL: 'Filipiinid',
  FRO: 'Fääri saared',
  GAB: 'Gabon',
  GMB: 'Gambia',
  GHA: 'Ghana',
  GIB: 'Gibraltar',
  GRD: 'Grenada',
  GEO: 'Gruusia',
  GRL: 'Gröönimaa',
  GLP: 'Guadeloupe',
  GUM: 'Guam',
  GTM: 'Guatemala',
  GGY: 'Guernsey',
  GIN: 'Guinea',
  GNB: 'Guinea-Bissau',
  GUY: 'Guyana',
  HTI: 'Haiti',
  HMD: 'Heard ja McDonald',
  CHN: 'Hiina',
  ESP: 'Hispaania',
  NLD: 'Holland',
  HND: 'Honduras',
  HKG: 'Hongkong',
  HRV: 'Horvaatia',
  TLS: 'Ida-Timor',
  IRL: 'Iirimaa',
  ISR: 'Iisrael',
  IND: 'India',
  IDN: 'Indoneesia',
  IRQ: 'Iraak',
  IRN: 'Iraan',
  ISL: 'Island',
  ITA: 'Itaalia',
  JPN: 'Jaapan',
  JAM: 'Jamaica',
  YEM: 'Jeemen',
  JEY: 'Jersey',
  JOR: 'Jordaania',
  CXR: 'Jõulusaar',
  CYM: 'Kaimanisaared',
  KHM: 'Kambodža',
  CMR: 'Kamerun',
  CAN: 'Kanada',
  KAZ: 'Kasahstan',
  QAT: 'Katar',
  KEN: 'Keenia',
  CAF: 'Kesk-Aafrika Vabariik',
  KIR: 'Kiribati',
  COM: 'Komoorid',
  COD: 'Kongo DV',
  COG: 'Kongo Vabariik',
  CCK: 'Kookossaared',
  GRC: 'Kreeka',
  CUB: 'Kuuba',
  KWT: 'Kuveit',
  KGZ: 'Kõrgõzstan',
  CYP: 'Küpros',
  LAO: 'Laos',
  LTU: 'Leedu',
  LSO: 'Lesotho',
  LBR: 'Libeeria',
  LIE: 'Liechtenstein',
  LBN: 'Liibanon',
  LBY: 'Liibüa',
  LUX: 'Luksemburg',
  ZAF: 'Lõuna-Aafrika Vabariik',
  SGS: 'Lõuna-Georgia ja Lõuna-Sandwichi saared',
  KOR: 'Lõuna-Korea',
  SSD: 'Lõuna-Sudaan',
  LVA: 'Läti',
  ESH: 'Lääne-Sahara',
  MAC: 'Macau',
  MDG: 'Madagaskar',
  MYS: 'Malaisia',
  MWI: 'Malawi',
  MDV: 'Maldiivid',
  MLI: 'Mali',
  MLT: 'Malta',
  IMN: 'Mani saar',
  MAR: 'Maroko',
  MHL: 'Marshalli Saared',
  MTQ: 'Martinique',
  MRT: 'Mauritaania',
  MUS: 'Mauritius',
  MYT: 'Mayotte',
  MEX: 'Mehhiko',
  FSM: 'Mikroneesia',
  MDA: 'Moldova',
  MCO: 'Monaco',
  MNG: 'Mongoolia',
  MNE: 'Montenegro',
  MSR: 'Montserrat',
  MOZ: 'Mosambiik',
  MMR: 'Myanmar',
  NAM: 'Namiibia',
  NRU: 'Nauru',
  NPL: 'Nepal',
  NIC: 'Nicaragua',
  NGA: 'Nigeeria',
  NER: 'Niger',
  NIU: 'Niue',
  NFK: 'Norfolk',
  NOR: 'Norra',
  OMN: 'Omaan',
  PNG: 'Paapua Uus-Guinea',
  PAK: 'Pakistan',
  PSE: 'Palestiina',
  PAN: 'Panama',
  PRY: 'Paraguay',
  PER: 'Peruu',
  PCN: 'Pitcairn',
  POL: 'Poola',
  PRT: 'Portugal',
  GUF: 'Prantsuse Guajaana',
  ATF: 'Prantsuse Lõunaalad',
  PYF: 'Prantsuse Polüneesia',
  FRA: 'Prantsusmaa',
  PRI: 'Puerto Rico',
  PRK: 'Põhja-Korea',
  MKD: 'Põhja-Makedoonia',
  MNP: 'Põhja-Mariaanid',
  REU: 'Réunion',
  CPV: 'Roheneemesaared (Cabo Verde)',
  SWE: 'Rootsi',
  ROU: 'Rumeenia',
  RWA: 'Rwanda',
  SLB: 'Saalomoni Saared',
  BLM: 'Saint-Barthélemy',
  SHN: 'Saint Helena',
  KNA: 'Saint Kitts ja Nevis',
  LCA: 'Saint Lucia',
  MAF: 'Saint-Martin (Prantsuse osa)',
  SPM: 'Saint-Pierre ja Miquelon',
  VCT: 'Saint Vincent',
  DEU: 'Saksamaa',
  ZMB: 'Sambia',
  WSM: 'Samoa',
  SMR: 'San Marino',
  STP: 'São Tomé ja Príncipe',
  SAU: 'Saudi Araabia',
  SYC: 'Seišellid',
  SEN: 'Senegal',
  SRB: 'Serbia',
  SLE: 'Sierra Leone',
  SGP: 'Singapur',
  SXM: 'Sint Maarten',
  SVK: 'Slovakkia',
  SVN: 'Sloveenia',
  SOM: 'Somaalia',
  FIN: 'Soome',
  LKA: 'Sri Lanka',
  SDN: 'Sudaan',
  SUR: 'Suriname',
  GBR: 'Suurbritannia',
  SWZ: 'Svaasimaa',
  SJM: 'Svalbard ja Jan Mayen',
  SYR: 'Süüria',
  CHE: 'Šveits',
  ZWE: 'Zimbabwe',
  DNK: 'Taani',
  TJK: 'Tadžikistan',
  THA: 'Tai',
  TWN: 'Taiwan',
  TZA: 'Tansaania',
  TGO: 'Togo',
  TKL: 'Tokelau',
  TON: 'Tonga',
  TTO: 'Trinidad ja Tobago',
  TCD: 'Tšaad',
  CZE: 'Tšehhi',
  CHL: 'Tšiili',
  TUN: 'Tuneesia',
  TCA: 'Turks ja Caicos',
  TUV: 'Tuvalu',
  TUR: 'Türgi',
  TKM: 'Türkmenistan',
  UGA: 'Uganda',
  UKR: 'Ukraina',
  HUN: 'Ungari',
  URY: 'Uruguay',
  VIR: 'USA Neitsisaared',
  UZB: 'Usbekistan',
  NCL: 'Uus-Kaledoonia',
  NZL: 'Uus-Meremaa',
  BLR: 'Valgevene',
  VUT: 'Vanuatu',
  VAT: 'Vatikan',
  RUS: 'Venemaa',
  VEN: 'Venezuela',
  VNM: 'Vietnam',
  WLF: 'Wallis ja Futuna',
  UMI: 'Ühendriikide hajasaared',
} as const;
